import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import React from 'react'

import { getCatalogUrlParts, useCatalogUrl } from '@/features/catalog/lib/catalog-url-context'

import { SortType } from '@/entities/catalog-old/types/type'

import { Select } from '@/shared/ui'

import { MobileSort } from './mobile-sort/mobile-sort'

import cls from './catalog-sort.module.scss'

type CatalogSortProps = {
	isMobile: boolean
	sortItems: {
		value: SortType
		label: string
	}[]
	onChange?: (value: SortType | string) => void
	withUrlParam?: boolean
}

export const CatalogSort = (props: CatalogSortProps) => {
	const { isMobile, sortItems, withUrlParam, onChange } = props
	const router = useRouter()
	const searchParams = useSearchParams()
	const pathname = usePathname()
	const catalogUrlState = useCatalogUrl()
	const catalogUrl =
		catalogUrlState?.resolvedUrl ?? `${pathname}${searchParams.toString() ? `?${searchParams.toString()}` : ''}`
	const { pathname: resolvedPathname, search } = getCatalogUrlParts(catalogUrl)
	const searchParamsSource = new URLSearchParams(search)

	// Получаем текущее значение сортировки из URL или используем первый элемент по умолчанию
	const sortFromUrl = searchParamsSource.get('sort') ?? undefined
	const currentSortValue = sortItems.find(item => item.value === sortFromUrl)?.value ?? sortItems[0].value

	const changeHandler = async (sort: SortType): Promise<void> => {
		await onChange?.(sort)

		if (withUrlParam) {
			await changeWithParam(sort)
		}
	}

	const changeWithParam = async (sort: SortType) => {
		const query = new URLSearchParams(search)
		query.set('sort', sort.toString())

		const nextUrl = `${resolvedPathname || pathname}?${query.toString()}`

		if (catalogUrlState) {
			catalogUrlState.updateResolvedUrl(nextUrl)
		} else {
			await router.push(nextUrl)
		}
	}

	return (
		<>
			{!isMobile && (
				<Select
					mobileModal
					mobileTitle="Сортировка товара"
					mobileCloseControl="cross"
					className={cls.sort}
					options={sortItems}
					value={currentSortValue}
					onChange={value => changeHandler?.(value as SortType)}
				/>
			)}
			{isMobile && (
				<MobileSort
					closeControl="cross"
					options={sortItems}
					value={currentSortValue}
					onChange={value => changeHandler?.(value)}
				/>
			)}
		</>
	)
}
